import { css } from 'emotion'
import { Colors } from '..'

export const SuccessStyle = css({
  display: 'inline-block',
  width: '100%',
  padding: '1rem 2rem',
  margin: '1rem 0px',
  border: `1px solid ${Colors.green}`,
  color: Colors.green,
  textAlign: 'center',
})

export const SuccessStyleInner = css({
  maxWidth: '284px',
  margin: '0 auto'
})


// WEBPACK FOOTER //
// ./src/styles/partials/success.js